import { render, staticRenderFns } from "./attorney_email.vue?vue&type=template&id=71291492&"
import script from "./attorney_email.vue?vue&type=script&lang=js&"
export * from "./attorney_email.vue?vue&type=script&lang=js&"
import style0 from "./attorney_email.vue?vue&type=style&index=0&id=71291492&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports